export default __webpack_public_path__ + "img/moon-cloud-rain.dfa3f1c.svg";